import { TodoTranslate } from './todoTranslate.model';

const todoTranslatePTBR: TodoTranslate = {
  list: {
    title: 'Tarefas',
    searchPlaceholder: 'Buscar tarefas...',
    emptyState: 'Nenhuma tarefa encontrada',
    emptyStateDetail: 'Crie uma nova tarefa usando o botão acima',
    tabs: {
      all: 'Todas',
      pending: 'Pendentes',
      done: 'Concluídas',
    },
  },
  form: {
    fields: {
      title: 'Título',
      description: 'Descrição',
      dueDate: 'Data limite',
      dueDateHint:
        'Sem data limite a tarefa não entra no lembrete diário por e-mail.',
      association: 'Vincular a...',
      associationNone: 'Nenhum',
      associationLead: 'Cliente',
      associationEvent: 'Evento',
      lead: 'Cliente',
      event: 'Evento',
      leadSearchPlaceholder: 'Buscar cliente',
      leadNoResults: 'Nenhum cliente encontrado',
      eventSearchPlaceholder: 'Buscar evento',
      eventNoResults: 'Nenhum evento encontrado',
    },
    errors: {
      title: {
        required: 'Título é obrigatório',
        maxLength: 'Título deve ter no máximo 200 caracteres',
      },
      description: {
        maxLength: 'Descrição deve ter no máximo 500 caracteres',
      },
      dueDate: {
        invalid: 'Data inválida',
      },
      xor: 'A tarefa não pode ser vinculada a um cliente e a um evento ao mesmo tempo',
    },
  },
  modal: {
    titleNew: 'Nova tarefa',
    titleEdit: 'Editando tarefa',
  },
  toast: {
    created: 'Tarefa criada com sucesso',
    updated: 'Tarefa atualizada com sucesso',
    deleted: 'Tarefa removida com sucesso',
    error: 'Erro ao salvar tarefa',
  },
  card: {
    editLabel: 'Editar tarefa',
    deleteLabel: 'Deletar tarefa',
    toggleLabel: 'Marcar tarefa "{{title}}" como concluída',
    due: {
      overdue: 'Atrasado há {{count}} dia',
      today: 'Vence hoje',
      tomorrow: 'Vence amanhã',
      inDays: 'Vence em {{count}} dias',
    },
  },
  widget: {
    title: 'Tarefas pendentes',
    viewAll: 'Ver todas',
    empty: 'Nenhuma tarefa pendente',
  },
};

export default todoTranslatePTBR;
